import {Component, Input, ViewEncapsulation} from '@angular/core';
import {MatDialog, PageEvent} from "@angular/material";
import {kanPartnersService} from "../../../../services/services/partners";
import {kanPartnerTypeDialog} from "../../../dialogs/partner-type-dialog/component";
import {PartnerType} from "../../../../../classes/partnerType";

@Component({
    selector: 'kan-partner-types',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanPartnerTypes {
    @Input() selectedTab: number;
    public partnerTypes: PartnerType[];
    public filteredPartnerTypes: PartnerType[];
    public pagedPartnerTypes: PartnerType[];
    public search: string;
    public pageIndex: number = 0;
    public pageSize: number = 20;

    constructor(private dialog: MatDialog, private partnerService: kanPartnersService) {

    }

    ngOnInit(): void {

    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 1) {
            this.getPartnerTypes();
        }
    }

    public getPartnerTypes(): void {
        this.partnerService.getPartnerTypes()
            .then((partnerTypes) => {
                this.partnerTypes = partnerTypes;
                this.filter();
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanPartnerTypeDialog, {
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getPartnerTypes();
            }
        });
    }

    public changePage(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.pageServices();
    }

    pageServices() {
        this.pagedPartnerTypes = this.filteredPartnerTypes.slice(this.pageIndex * this.pageSize, (this.pageIndex + 1) * this.pageSize);
    }

    public filter() {
        this.filteredPartnerTypes = this.partnerTypes.filter((partnerType) => {
            let found = true;

            if (this.search) {

                let arr = this.search.split(' ');

                arr.forEach((item) => {

                    if (item) {
                        found = found &&
                            (
                                String(partnerType.type).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1 ||
                                String(partnerType.description).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1
                            );
                    }
                });
            }

            return found;
        });

        this.pageServices();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/partner-type/partner-types/component.ts